export default __webpack_public_path__ + "static/media/bi-mat-cua-gio-sneakshow-16056745070206.29224329.jpg";